import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tUsers\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-lock" }, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Export CSV", -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add User", -1 /* HOISTED */);
const _hoisted_11 = { class: "form-contents" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "clearfix" };
const _hoisted_14 = { class: "clearfix" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_16 = { class: "input-group top_search" };
const _hoisted_17 = { class: "input-group-btn" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_21 = { class: "input-group top_search" };
const _hoisted_22 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_23 = { class: "input-group top_search" };
const _hoisted_24 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_25 = { class: "input-group top_search" };
const _hoisted_26 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_27 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_28 = { class: "float-end left5" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* HOISTED */);
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix top10" }, [
    /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_31 = { class: "clearfix pad10" };
const _hoisted_32 = { class: "float-end" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_34 = {
    key: 0,
    class: "float-end"
};
const _hoisted_35 = { class: "float-end hidden-xs record-count" };
const _hoisted_36 = { class: "col-xs-12 col-sm-12" };
const _hoisted_37 = { class: "card bg-white data-grid users-grid detached overflow-x-auto" };
const _hoisted_38 = { class: "table table-hover bottom0 pw100" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* HOISTED */);
const _hoisted_40 = { key: 0 };
const _hoisted_41 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_42 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_43 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_44 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_45 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_46 = {
    key: 6,
    class: "hidden-sm"
};
const _hoisted_47 = {
    key: 7,
    class: "hidden-sm"
};
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, null, -1 /* HOISTED */);
const _hoisted_49 = { class: "text-center hidden-sm" };
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-unlock" }, null, -1 /* HOISTED */);
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_54 = { key: 0 };
const _hoisted_55 = { key: 0 };
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-lock" }, null, -1 /* HOISTED */);
const _hoisted_57 = [
    _hoisted_56
];
const _hoisted_58 = { class: "clearfix visible-sm" };
const _hoisted_59 = { key: 0 };
const _hoisted_60 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-lock" }, null, -1 /* HOISTED */);
const _hoisted_61 = [
    _hoisted_60
];
const _hoisted_62 = { class: "clearfix" };
const _hoisted_63 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_64 = { class: "float-start right5" };
const _hoisted_65 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-address-card-o" }, null, -1 /* HOISTED */);
const _hoisted_66 = { class: "float-start right5" };
const _hoisted_67 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-phone" }, null, -1 /* HOISTED */);
const _hoisted_68 = { class: "float-start" };
const _hoisted_69 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-at" }, null, -1 /* HOISTED */);
const _hoisted_70 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_71 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_72 = ["title"];
const _hoisted_73 = ["title"];
const _hoisted_74 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_75 = {
    key: 6,
    class: "hidden-sm"
};
const _hoisted_76 = {
    key: 7,
    class: "hidden-sm"
};
const _hoisted_77 = { class: "text-center" };
const _hoisted_78 = { key: 0 };
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", {
        class: "text-center",
        colspan: "9"
    }, [
        /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_80 = [
    _hoisted_79
];
const _hoisted_81 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_82 = { class: "checkbox-wrapper" };
const _hoisted_83 = { class: "checkbox-wrapper" };
const _hoisted_84 = { class: "float-end float-start-sm" };
const _hoisted_85 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
const _hoisted_86 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_TimerVue = _resolveComponent("TimerVue");
    const _component_b_container = _resolveComponent("b-container");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_lock_unlock_users_modal = _resolveComponent("lock-unlock-users-modal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                        variant: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.lockUnlokUsersModal.showModal()))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_6,
                            _createTextVNode(" Lock/Unlock Users\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createTextVNode(),
                    (_ctx.isPowerShieldAdministrator)
                        ? (_openBlock(), _createBlock(_component_b_button, {
                            key: 0,
                            variant: "primary",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.showExportUsersModal = true))
                        }, {
                            default: _withCtx(() => [
                                _hoisted_7,
                                _hoisted_8
                            ]),
                            _: 1 /* STABLE */
                        }))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    _withDirectives(_createVNode(_component_router_link, { to: { name: 'user' } }, {
                        default: _withCtx(() => [
                            _createVNode(_component_b_button, { variant: "primary" }, {
                                default: _withCtx(() => [
                                    _hoisted_9,
                                    _hoisted_10
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                        [_vShow, !_ctx.isThirdPartyAuth]
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_b_form_input, {
                                    type: "text",
                                    modelValue: _ctx.query.keywords,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.keywords) = $event)),
                                    modelModifiers: { trim: true },
                                    placeholder: "Search for...",
                                    onKeyup: _withKeys(_ctx.search, ["enter"]),
                                    required: ""
                                }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                                _createTextVNode(),
                                _createElementVNode("span", _hoisted_17, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-default",
                                        onClick: _cache[3] || (_cache[3] =
                                            //@ts-ignore
                                            (...args) => (_ctx.search && _ctx.search(...args)))
                                    }, _hoisted_19)
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.company,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.company) = $event)),
                                    options: _ctx.companies,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "Any company",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.site,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.site) = $event)),
                                    options: _ctx.filteredSites,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "Any site",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.role,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.role) = $event)),
                                    options: _ctx.roles,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "Any role",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _createTextVNode(),
                        (_ctx.searchAttempted)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _createVNode(_component_b_dropdown, {
                                            ref: "columnSettingsDropdown",
                                            "no-caret": "",
                                            end: "",
                                            sm: "",
                                            "auto-close": false,
                                            variant: "outline-secondary outline-secondary-pagination",
                                            disabled: _ctx.working
                                        }, {
                                            "button-content": _withCtx(() => [
                                                _hoisted_29
                                            ]),
                                            default: _withCtx(() => [
                                                _createTextVNode(),
                                                _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_form_group, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_b_form_checkbox, {
                                                                    id: "includeDeleted",
                                                                    modelValue: _ctx.query.includeDeleted,
                                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.query.includeDeleted) = $event))
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                    ]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["modelValue"])
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }),
                                                        _createTextVNode(),
                                                        _hoisted_30,
                                                        _createTextVNode(),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIdx) => {
                                                            return (_openBlock(), _createBlock(_component_b_form_group, {
                                                                key: column.fieldName
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_form_group, null, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_b_form_checkbox, {
                                                                                id: column.fieldName,
                                                                                modelValue: column.visible,
                                                                                "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                                ]),
                                                                                _: 2 /* DYNAMIC */
                                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }),
                                                _createTextVNode(),
                                                _createVNode(_component_b_dropdown_divider),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("div", _hoisted_32, [
                                                        _createVNode(_component_b_button, {
                                                            variant: "secondary",
                                                            right: "",
                                                            sm: "",
                                                            onClick: _ctx.closeColumnSettingsMenu
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _hoisted_33,
                                                                _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["onClick"])
                                                    ])
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"])
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.numberOfVisibleColumns)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                            _createVNode(_component_b_pagination, {
                                                class: "float-end",
                                                modelValue: _ctx.query.pageNo,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.query.pageNo) = $event)),
                                                "per-page": _ctx.query.pageSize,
                                                "total-rows": _ctx.data.recordCount,
                                                "hide-ellipsis": true,
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_35, "\r\n\t\t\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("table", _hoisted_38, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _hoisted_39,
                                    _createTextVNode(),
                                    (_ctx.isVisible('userName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_40, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'UserName', title: 'Username' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('firstName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_41, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'FirstName', title: 'First Name' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('lastName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_42, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'LastName', title: 'Last Name' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('companies'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_43, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'Companies', title: 'Company Name(s)' }
                                            }, null, 8 /* PROPS */, ["sorter", "column"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('sites'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_44, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'Sites', title: 'Site Name(s)' }
                                            }, null, 8 /* PROPS */, ["sorter", "column"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('emailAddress'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_45, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'EmailAddress', title: 'Email' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('roleName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_46, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'RoleName', title: 'Role' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    (_ctx.isVisible('lastLogin'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_47, [
                                            _createVNode(_component_SortableColumnComponent, {
                                                sorter: _ctx.sorter,
                                                column: { fieldName: 'WhenLastLoggedIn', title: 'Last Login' }
                                            }, null, 8 /* PROPS */, ["sorter"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    _hoisted_48
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        class: _normalizeClass({ 'deleted': item.whenDeleted })
                                    }, [
                                        _createElementVNode("td", _hoisted_49, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_50,
                                                                    _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                            _createTextVNode(),
                                                            (item.whenLockoutEnds && _ctx.isPowerShield)
                                                                ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                                                                    key: 0,
                                                                    onClick: ($event) => (_ctx.unlock(item))
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _hoisted_51,
                                                                        _createTextVNode(" Unlock\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                                                : _createCommentVNode("v-if", true),
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _createTextVNode(),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.archive(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_52,
                                                                    _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                                [_vShow, !item.whenDeleted && !_ctx.isThirdPartyAuth]
                                                            ]),
                                                            _createTextVNode(),
                                                            _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.restore(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_53,
                                                                    _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                                [_vShow, item.whenDeleted && !_ctx.isThirdPartyAuth]
                                                            ])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.isVisible('userName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_54, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'user', params: { 'id': item.userId } },
                                                    class: "blue hidden-sm"
                                                }, {
                                                    default: _withCtx(() => [
                                                        (item.whenLockout)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_55, _hoisted_57))
                                                            : _createCommentVNode("v-if", true),
                                                        _createTextVNode(" " + _toDisplayString(item.userName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_58, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'user', params: { 'id': item.userId } },
                                                        class: "lead"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (item.whenLockout)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_59, _hoisted_61))
                                                                : _createCommentVNode("v-if", true),
                                                            _createTextVNode(" " + _toDisplayString(item.userName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_62, _toDisplayString(item.roleName), 1 /* TEXT */),
                                                    _createTextVNode(),
                                                    (item.personId)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                                            _createElementVNode("div", _hoisted_64, [
                                                                _hoisted_65,
                                                                _createTextVNode(" " + _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1 /* TEXT */)
                                                            ]),
                                                            _createTextVNode(),
                                                            _withDirectives(_createElementVNode("div", _hoisted_66, [
                                                                _hoisted_67,
                                                                _createTextVNode(" " + _toDisplayString(item.mobilePhone), 1 /* TEXT */)
                                                            ], 512 /* NEED_PATCH */), [
                                                                [_vShow, item.mobilePhone]
                                                            ]),
                                                            _createTextVNode(),
                                                            _withDirectives(_createElementVNode("div", _hoisted_68, [
                                                                _hoisted_69,
                                                                _createTextVNode(" " + _toDisplayString(item.emailAddress), 1 /* TEXT */)
                                                            ], 512 /* NEED_PATCH */), [
                                                                [_vShow, item.emailAddress]
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('firstName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_70, _toDisplayString(item.firstName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('lastName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_71, _toDisplayString(item.lastName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('companies'))
                                            ? (_openBlock(), _createElementBlock("td", {
                                                key: 3,
                                                class: "large-text-ellipsis hidden-sm",
                                                title: item.companies
                                            }, _toDisplayString(item.companies), 9 /* TEXT, PROPS */, _hoisted_72))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('sites'))
                                            ? (_openBlock(), _createElementBlock("td", {
                                                key: 4,
                                                class: "large-text-ellipsis hidden-sm",
                                                title: item.sites
                                            }, _toDisplayString(item.sites), 9 /* TEXT, PROPS */, _hoisted_73))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('emailAddress'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_74, _toDisplayString(item.emailAddress), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('roleName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_75, _toDisplayString(item.roleName), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('lastLogin'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_76, _toDisplayString(_ctx.whenLastLoggedInString(item)), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_77, [
                                            (_openBlock(), _createBlock(_component_TimerVue, {
                                                key: item.userId,
                                                endTime: item.whenLockoutEnds,
                                                label: "Lock-Out Active:",
                                                cssClass: "user-status badge badge-warning"
                                            }, null, 8 /* PROPS */, ["endTime"]))
                                        ])
                                    ], 2 /* CLASS */));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_78, _hoisted_80))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            modelValue: _ctx.showExportUsersModal,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.showExportUsersModal) = $event)),
            id: "modal-export-csv",
            "header-bg-variant": "normal",
            size: "md"
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\t\tExport Users and Contacts to CSV\r\n\t\t\t")
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_84, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.exportToPdf
                    }, {
                        default: _withCtx(() => [
                            _hoisted_85,
                            _createTextVNode(" Export\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.showExportUsersModal = false))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_86,
                            _createTextVNode(" Close\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("div", _hoisted_82, [
                                _createVNode(_component_b_form_checkbox, {
                                    modelValue: _ctx.exportQuery.exportUsers,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.exportQuery.exportUsers) = $event)),
                                    size: "lg"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\tExport Users\r\n\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_83, [
                                _createVNode(_component_b_form_checkbox, {
                                    modelValue: _ctx.exportQuery.exportContacts,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.exportQuery.exportContacts) = $event)),
                                    size: "lg"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\tExport Contacts\r\n\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode(),
                _createTextVNode(),
                _createVNode(_component_StatusOverlayComponent, {
                    visible: _ctx.working,
                    message: "Loading..."
                }, null, 8 /* PROPS */, ["visible"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createTextVNode(),
        _createVNode(_component_lock_unlock_users_modal, {
            ref: "lockUnlokUsersModal",
            companies: _ctx.companies,
            onUsersUpdated: _ctx.search
        }, null, 8 /* PROPS */, ["companies", "onUsersUpdated"])
    ]));
}
